export const PARTNER_ONBOARDING_RETURN = 'bloom.partnerOnboardingReturn';
export function partnerOnboardingReturnPath() {
  const id = sessionStorage.getItem(PARTNER_ONBOARDING_RETURN);
  return id && /^[a-f0-9]{24}$/i.test(id) ? `/partner-onboarding/${id}` : null;
}
